"use client";

import { useEffect, useState } from "react";
import { useAuthorStore } from "@/stores/authorStore";
import { API_CONFIG } from "@/config/api";

interface ModalViewAuthorProps {
  isOpen: boolean;
  onClose: () => void;
  authorId: string | null;
}

export default function ModalViewAuthor({ isOpen, onClose, authorId }: ModalViewAuthorProps) {
  const { fetchAuthorById } = useAuthorStore();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (isOpen && authorId) {
        setLoading(true);
        const res = await fetchAuthorById(authorId);
        setData(res);
        setLoading(false);
      }
    };
    run();
  }, [isOpen, authorId, fetchAuthorById]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Chi tiết tác giả</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">×</button>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600">Đang tải...</span>
          </div>
        ) : !data ? (
          <div className="p-6 text-center text-gray-600">Không tìm thấy tác giả</div>
        ) : (
          <div className="p-6 space-y-4">
            <div>
              <div className="text-sm text-gray-500">Tên tác giả</div>
              <div className="text-base font-medium text-gray-900">{data.name}</div>
            </div>
            {data.image && (
              <div>
                <div className="text-sm text-gray-500">Hình ảnh</div>
                <div className="mt-2">
                  <img
                    src={String(data.image).startsWith('http') ? data.image : `${API_CONFIG.API_FILE_URL}${data.image}`}
                    alt={data.name}
                    className="max-h-64 w-auto rounded-xl border object-contain"
                  />
                </div>
              </div>
            )}
            {data.info && (
              <div>
                <div className="text-sm text-gray-500">Thông tin</div>
                <div className="text-base text-gray-900 whitespace-pre-line">{data.info}</div>
              </div>
            )}
          </div>
        )}

        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">Đóng</button>
        </div>
      </div>
    </div>
  );
}


